import Vue from 'vue'
import axios from 'axios'
import { Inertia } from '@inertiajs/inertia'
import { InertiaProgress } from '@inertiajs/progress'
import store from './store'
import { createInertiaApp, Link } from '@inertiajs/inertia-vue'

import { configureAxiosCsrf } from '../common/js/csrf-axios'
import { legacyUrl, filamentUrl } from '../common/adminUrls'
import '../common/css/nprogress.css'

window.axios = axios
configureAxiosCsrf(axios)

import VPopover from 'vue-js-popover'
import imagePath from './mixins/imagePath'
import { installVuelidateLegacy } from '../common/vuelidate-legacy'
import VueToast from 'vue-toast-notification/src/index'
import VModal from 'vue-js-modal'
import moment from 'moment/min/moment-with-locales'
import VueMoment from 'vue-moment'
import AppSwiper from '@app/components/Wrappers/Swiper'
import SwiperSlide from '@app/components/Wrappers/SwiperSlide'
import 'moment/locale/ru.js'
import '../common/index.scss'
import '../app/index.scss'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import './index.css'
import './extends'
import modalCaller from './libs/modalCaller'
import LayoutGrey from './components/Layout/IndexGrey'
import * as mtsPolls from './libs/mts-polls'
import * as analytics from './libs/analytics'
import { fireSCRNEvent } from './libs/analytics'
import VCalendar from 'v-calendar'
export { EventBus } from './libs/event-bus'
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers'
import ExternalLink from '@app/components/Layout/ExternalLink'
import VueMask from 'v-mask'
import validateSso from './libs/validate-sso'
import { cleanupLegacyClientStorage } from './libs/cleanup-client-storage'

cleanupLegacyClientStorage()

const emailVerifyHash = window.location.hash || ''
if (/^#token=/.test(emailVerifyHash)) {
  const path = window.location.pathname
  if (path !== '/user/verify' && path !== '/login-as') {
    window.location.replace('/user/verify' + emailVerifyHash)
  }
}

import VTooltip from 'v-tooltip'
import safeHtml from './directives/safeHtml'
import { overrideModalsPlugin } from './plugins/modals'

overrideModalsPlugin()

Vue.use(VTooltip)
Vue.directive('safe-html', safeHtml)


Vue.use(VueMask)
Vue.use(VCalendar, {
  componentPrefix: 'vc'  // <vc-calendar />
})

Vue.$isIE = !!document.documentMode
Vue.config.performance = true

Vue.prototype.$legacyUrl = legacyUrl
Vue.prototype.$filamentUrl = filamentUrl
globalThis.legacyUrl = legacyUrl
globalThis.filamentUrl = filamentUrl

Vue.mixin({
  methods: {
    legacyUrl,
    filamentUrl
  }
})

Vue.use(VPopover, { tooltip: true })

Vue.component('InertiaLink', Link)
Vue.component('ExternalLink', ExternalLink)
Vue.mixin(imagePath)

installVuelidateLegacy(Vue)
Vue.use(VueToast, {
  position: 'top-right',
  dismissible: true,
  duration: 10000
})
Vue.use(VModal, { dynamic: true, injectModalsContainer: true, dynamicDefaults: { clickToClose: true } })
moment.locale('ru')
Vue.use(VueMoment, { moment })
Vue.component('swiper', AppSwiper)
Vue.component('swiper-slide', SwiperSlide)

Inertia.on('navigate', event => {
  store.dispatch('auth/setAuthUser', event.detail.page.props.user ?? null)
  store.dispatch('auth/setAuthAdmin', event.detail.page.props.admin ?? null)
  Vue.$showNotifications(event.detail.page.props.admin?.notification ?? {})
  modalCaller(Vue.prototype.$modal, event.detail.page.props.modal)
  console.debug('inerita.navigate', event.detail.page)

  mtsPolls.callEvent(event.detail.page)
  analytics.callEvent(event.detail.page)
  analytics.fireSCRNEvent(event.detail.page)

  validateSso(event.detail.page.props)

})
Inertia.on('success', event => {
  store.dispatch('auth/setAuthUser', event.detail.page.props.user ?? null)
  store.dispatch('auth/setAuthAdmin', event.detail.page.props.admin ?? null)
  Vue.$showNotifications(event.detail.page.props.admin?.notification ?? {})
  modalCaller(Vue.prototype.$modal, event.detail.page.props.modal)
  console.debug('inerita.success', event.detail.page)
  mtsPolls.callEvent(event.detail.page)
  analytics.callEvent(event.detail.page)
})

InertiaProgress.init({
  delay: 250,
  color: '#E30611',
  includeCSS: false,
  showSpinner: false
})

document.addEventListener(
  'inertia:navigate',
  async event => {
    if (import.meta.env.MODE === 'production') {
      await mtsPolls.init(Vue.prototype.$modal, event.detail.page)
    }
  },
  { once: true }
)

createInertiaApp({
  id: 'app',
  resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue'), ),
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)
    Vue.prototype.$store = store
    store.dispatch('auth/setAuthUser', props.props.initialPage.props.user ?? null)
    store.dispatch('auth/setAuthAdmin', props.props.initialPage.props.admin ?? null)

    new Vue({
      store,
      render: h => h(App, props)
    }).$mount(el)
  }
})

window.addEventListener('popstate', () => {
  window.location.reload()
});

window.Vue = Vue
